module.exports = __webpack_public_path__ + "static/img/p1.912feddd.png";